import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'antd';
import { ROUTES } from 'utils/utils';

export default class Code455 extends Component {
    constructor(props) { super(props); }
    render() {
        const { styleProps, services, reset } = this.props;
        return (
            <div>
                <div {...styleProps.textDiv}>{'Notice'}</div>
                <Row type='flex' justify='space-around' align='middle' style={{ margin: '12px 0px 18px 0px' }}>
                    <Col span={14}>
                        <div style={{ fontStyle: 'italic' }}>
                            <div>
                                {'Account has expired. '}
                            </div>
                            <div style={{ fontWeight: 'bold' }}>
                                {'Please update your password.'}
                            </div>
                        </div>
                    </Col>
                </Row>
                <div {...styleProps.indicatorDiv}>
                    <Link to={ROUTES.HOME.RESET_EXPIRED_PASSWORD}>
                        <Button
                            icon='link'
                            style={{ fontSize: '14px', width: '200px', borderRadius: '20px' }}
                            onClick={() => {
                                reset();
                            }}
                        >{'Update Password'}</Button>
                    </Link>
                </div>
            </div>
        );
    }
}
